import { useLocale, useTranslations } from 'next-intl';
import type { MouseEventHandler } from 'react';

import { EventType } from '@/analytics/types';
import womensHealthPress from '@/app/[locale]/womens-health/_data/womensHealthPress';
import ArticleCardsModule from '@/app/components/ArticleCardsModule';
import ArticleCardTag from '@/app/components/ArticleCardsModule/ArticleCardTag';
import getLocalePartialUrl from '@/utils/getLocalePartialUrl';

const WomensHealthArticles = () => {
  const t = useTranslations();
  const locale = useLocale();
  const articles = womensHealthPress(getLocalePartialUrl(locale));

  const handleLinkClick: MouseEventHandler<HTMLAnchorElement> = (event) => {
    const { href } = event.currentTarget;
    const url = new URL(href);
    void window.ouraAnalytics.track(EventType.LinkClicked, {
      cta: 'read_more',
      location: 'womens health press',
      action: 'goes to blog',
      path: url.pathname,
    });
  };

  return (
    <ArticleCardsModule
      {...articles}
      data-cy="womens-health-press"
      eyebrowText="pulse_blog_eyebrow"
      eyebrowTextColor="light"
      imageTag={() => (
        <ArticleCardTag tag="featured_article_tag" textColor="sandstone-500" />
      )}
      mobileSliderAriaLabels={[
        t('press_section_slide_label_menstrual_cycle'),
        t('press_section_slide_label_natural_cycles'),
        t('press_section_slide_label_pregnancy'),
      ]}
      onClick={handleLinkClick}
      swipeableDotsProps={{
        activeColor: 'sandstone-200',
        color: 'gray-400',
      }}
      wrapperClass="bg-olive-600 text-olive-800"
    />
  );
};
export default WomensHealthArticles;
